/**
 * Shadow System
 * Multi-layer shadows for depth and elevation
 */

export const shadows = {
  // Base shadows (MUI compatible - array of 25 shadows)
  none: 'none',

  // Subtle elevation
  xs: '0 1px 2px 0 rgba(15, 46, 61, 0.05)',
  sm: '0 1px 3px 0 rgba(15, 46, 61, 0.1), 0 1px 2px -1px rgba(15, 46, 61, 0.1)',
  md: '0 4px 6px -1px rgba(15, 46, 61, 0.1), 0 2px 4px -2px rgba(15, 46, 61, 0.1)',
  lg: '0 10px 15px -3px rgba(15, 46, 61, 0.1), 0 4px 6px -4px rgba(15, 46, 61, 0.1)',
  xl: '0 20px 25px -5px rgba(15, 46, 61, 0.1), 0 8px 10px -6px rgba(15, 46, 61, 0.1)',
  '2xl': '0 25px 50px -12px rgba(15, 46, 61, 0.25)',

  // Inner shadows
  inner: 'inset 0 2px 4px 0 rgba(15, 46, 61, 0.05)',

  // Colored shadows for emphasis
  primaryGlow: '0 4px 20px rgba(8, 131, 149, 0.3)',
  secondaryGlow: '0 4px 20px rgba(0, 217, 255, 0.3)',
  successGlow: '0 4px 20px rgba(32, 227, 178, 0.3)',
  errorGlow: '0 4px 20px rgba(255, 107, 107, 0.3)',

  // Card shadows with multiple layers
  card: '0 1px 3px 0 rgba(15, 46, 61, 0.1), 0 1px 2px -1px rgba(15, 46, 61, 0.1)',
  cardHover: '0 10px 15px -3px rgba(15, 46, 61, 0.1), 0 4px 6px -4px rgba(15, 46, 61, 0.1), 0 0 0 1px rgba(8, 131, 149, 0.1)',

  // Glass morphism
  glass: '0 8px 32px 0 rgba(15, 46, 61, 0.1)',
} as const;

// MUI compatible shadows array (25 items required)
export const muiShadows: [
  'none',
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
] = [
  'none',
  shadows.xs,
  shadows.sm,
  shadows.md,
  shadows.md,
  shadows.lg,
  shadows.lg,
  shadows.lg,
  shadows.xl,
  shadows.xl,
  shadows.xl,
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
  shadows['2xl'],
];
